import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

const icons = {
  digestion: 'M78,70H20a12,12,0,0,1,0-24h1.06A12,12,0,0,1,30,26H68a2,2,0,0,1,0,4H30a8,8,0,0,0,0,16H80a2,2,0,0,1,0,4H20a8,8,0,0,0,0,16H78a2,2,0,0,1,0,4Z"/><path d="M50,30A12,12,0,0,1,38,18V12a2,2,0,0,1,4,0v6a8,8,0,0,0,8,8,2,2,0,0,1,0,4Z"/><path d="M50,90a2,2,0,0,1-2-2A12,12,0,0,1,60,76H80a8,8,0,0,0,0-16H20a2,2,0,0,1,0-4H80a8,8,0,0,0,0-16H30a2,2,0,0,1,0-4H70a8,8,0,0,0,0-16H54.23A6.24,6.24,0,0,1,48,13.77V12a2,2,0,0,1,4,0v1.77A2.23,2.23,0,0,0,54.23,16H70a12,12,0,0,1,8.94,20H80a12,12,0,0,1,6.63,22A12,12,0,0,1,80,80H60a8,8,0,0,0-8,8A2,2,0,0,1,50,90Z"/><path d="M40,90a2,2,0,0,1-2-2V78A12,12,0,0,1,50,66h1a2,2,0,0,1,0,4H50a8,8,0,0,0-8,8V88A2,2,0,0,1,40,90Z'
};

const Icon = ({ icon, size }) => (
  <svg width={size} height={size} viewBox='0 0 1024 1024'>
    <path d={icons[icon]}></path>
  </svg>
);

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number
};

Icon.defaultProps = {
  size: 128
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.jsx